import type { PropsWithChildren } from 'react'
import styles from './Sidebar.module.css'

type SectionProps = PropsWithChildren<{
  title: string
  variant?: 'default' | 'highlighted'
}>

export function Section({ title, children, variant = 'default' }: SectionProps) {
  const variantClasses = {
    default: '',
    highlighted: `surface-50 p-3 shadow-1 ${styles.highlighted}`,
  }

  return (
    <section className={`${styles.section} ${variantClasses[variant]}`}>
      <h2 className="uppercase text-900 text-sm mb-3 mt-0">{title}</h2>
      <div>{children}</div>
    </section>
  )
}
